export const personIdRegex = '^[A-NP-Z0-9]{3}-[A-NP-Z0-9]{5}$';
